import { Validator } from "./types";
import { SearchContextType } from "../search-context";
import ValidationErrorMessages from "./error-messages";

const validatePassportSearch: Validator = (data: SearchContextType) => {
  const { passportNumber, firstName, middleNames, lastName, dateOfBirth } =
    data;

  const hasPassport = !!passportNumber?.trim();
  const hasAnyOtherValue =
    !!firstName?.trim() ||
    !!middleNames?.trim() ||
    !!lastName?.trim() ||
    !!dateOfBirth?.toString().trim();

  const isPassportOnlySearch = hasPassport && !hasAnyOtherValue;

  if (!hasPassport) {
    return { isValid: false, errors: [] };
  }

  return isPassportOnlySearch
    ? { isValid: true, errors: [] }
    : { isValid: false, errors: [ValidationErrorMessages.invalidPassport] };
};

export default validatePassportSearch;
